import { getConnector } from '../services/PatientFacingClient';
import { RootDispatch, RootState } from '../store';
import { CallEvent } from '../types';
import { ClientConnector } from '../services/sdkConnector/ClientConnector';

export interface Call {
  incomingCall?: CallEvent;
}

const initialState: Call = {
  incomingCall: undefined,
};

let timeoutRef: number | undefined;

export const call = {
  effects: (dispatch: RootDispatch) => ({
    async acceptCall(event: MouseEvent, rootState: RootState) {
      if (!rootState.call.incomingCall) return;

      const { origin, pathname, search } = window.location;
      const urlParams = new URLSearchParams(search);
      const isVwrOrigin = urlParams.has('v');
      const path = pathname.replace(isVwrOrigin ? '/vw' : '/mm', '/mv');
      urlParams.delete('t');
      urlParams.delete('v');
      urlParams.set('c', rootState.call.incomingCall?.accessToken);
      urlParams.set('source', 'ma');
      dispatch.call.handleCallEvent(undefined);
      window.open(`${origin + path}?${urlParams.toString()}`);
    },
    async declineCall(event: MouseEvent, rootState: RootState) {
      // https://tigertext.atlassian.net/browse/APP-101
      const { client } = getConnector() as ClientConnector;
      if (!rootState.call.incomingCall?.roomName) return;
      await client.calls.decline(rootState.call.incomingCall.roomName);
      dispatch.call.handleCallEvent(undefined);
    },
    handleCallEvent(callEvent: CallEvent | undefined, rootState: RootState) {
      if (
        callEvent?.callStatus === 'ended' &&
        callEvent?.payload?.userToken !== rootState.call?.incomingCall?.payload?.callerId
      ) {
        return;
      }
      callEvent = callEvent?.callStatus === 'incoming' ? callEvent : undefined;
      if (timeoutRef) {
        clearTimeout(timeoutRef);
        timeoutRef = undefined;
      }
      if (callEvent && callEvent.ttl !== -1) {
        // eslint-disable-next-line scanjs-rules/call_setTimeout
        timeoutRef = window.setTimeout(
          () => dispatch.call.handleCallEvent(undefined),
          callEvent.ttl * 1000
        );
      }

      dispatch.call.updateIncomingCall(callEvent);
    },
    handleCallDelete(callEvent: CallEvent | undefined, rootState: RootState) {
      if (callEvent?.roomName !== rootState.call?.incomingCall?.roomName) return;
      dispatch.call.updateIncomingCall(undefined);
    },
  }),
  reducers: {
    updateIncomingCall: (state: Call, incomingCall: CallEvent | undefined): Call =>
      Object.assign({}, state, { incomingCall }),
  },
  state: initialState,
};
